/**
 * Email format check for the block project-customer-master-data (plan decided 2): empty is
 * allowed; a non-empty value must look like local@domain with a dot in the domain.
 */
export const CUSTOMER_MASTER_DATA_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidCustomerMasterDataEmail(value) {
  if (value == null || value === '') {
    return true;
  }

  return CUSTOMER_MASTER_DATA_EMAIL_PATTERN.test(String(value));
}

/**
 * `Project.customer` fields saved by the block project-customer-master-data. Must match
 * `ProjectCustomerMasterDataInput` in the API schema.
 */
export const PROJECT_CUSTOMER_MASTER_DATA_INPUT_FIELDS = [
  'salutation',
  'company',
  'firstname',
  'lastname',
  'street',
  'streetNumber',
  'streetNumberSuffix',
  'zip',
  'city',
  'cityPart',
  'phone',
  'phone2',
  'phone3',
  'mobile',
  'mobile2',
  'email',
  'email2',
  'birthdayAt',
];

/**
 * `ProjectCustomerMasterDataInput` from the block object (or the stored project): the eighteen
 * fields of `customer`, a missing field as `null`, `birthdayAt` null when empty.
 */
export const toProjectCustomerMasterDataInput = (project) => {
  const customer = project.customer ?? {};

  return Object.fromEntries(
    PROJECT_CUSTOMER_MASTER_DATA_INPUT_FIELDS.map((field) => {
      if (field === 'birthdayAt') {
        return [field, customer.birthdayAt ? customer.birthdayAt : null];
      }

      return [field, customer[field] ?? null];
    })
  );
};
